import { ROLE, ROLE_ORDER } from '../lib/types';

export const sortRoles = (a: ROLE, b: ROLE) => ROLE_ORDER.indexOf(a) - ROLE_ORDER.indexOf(b);
